var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"sidebar-nav"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fi flaticon-home"})]),_vm._v("\n      "+_vm._s(_vm.$t('dashboard'))+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }